export enum LoginFailStatus {
  MISSING_SIGNIN_NAME = "missingSigninName",
  MISSING_AUTH_TOKEN = "missingAuthToken",
  REDIRECT_NOT_ALLOWED = "redirectNotAllowed",
  ASSET_NOT_FOUND = "assetNotFound",
}
